import { CallRoute } from '@weave/schema-gen-ts/dist/schemas/phone/callroute/v1/callroute_service.pb';
import { CallRouteV1 } from '@frontend/api-call-route';
import { SettingsTenantLocation } from '@frontend/phone-config';
import { useCallObjectsData } from '../../use-call-objects-data';

export type NodeState = Omit<CallRouteV1.Types.Node, 'id'>;

// This type extracts a specific node type from the union of all possible node types
export type NodeStateOfType<T extends NodeState['type']> = Omit<Extract<CallRouteV1.Types.Node, { type: T }>, 'id'>;

// Type guard that checks if a NodeState is of a specific type
export function isNodeStateOfType<T extends NodeState['type']>(
  nodeState: NodeState,
  type: T
): nodeState is NodeStateOfType<T> {
  return nodeState.type === type;
}

export type AdditionalNodeData = {
  dialOptions?: string[];
};
export type NodeStateWithAdditionalData = { nodeState: NodeState; additionalData: AdditionalNodeData };

// Type that holds node state of a specific type with additional data
export type NodeStateWithAdditionalDataOfType<T extends NodeState['type'] = NodeState['type']> = {
  nodeState: NodeStateOfType<T>;
  additionalData: AdditionalNodeData;
};

// Type guard to check if NodeStateWithAdditionalData is of a specific type
export function isNodeStateWithAdditionalDataOfType<T extends NodeState['type']>(
  data: NodeStateWithAdditionalData,
  type: T
): data is NodeStateWithAdditionalDataOfType<T> {
  return data.nodeState.type === type;
}

export type AddStepPanelProps<T extends NodeState['type']> = {
  initialState: NodeStateOfType<T> | undefined;
  callObjectsData: ReturnType<typeof useCallObjectsData>;
  tenantId: string;
  settingsTenantLocation?: SettingsTenantLocation;
  isDeviceExtensionRoute?: boolean;
  callRoute: CallRoute;
  onClose: () => void;
  onBackClick: () => void;
  onCancelClick: () => void;
  onProceedClick: (updates: NodeStateOfType<T>, additionalData?: AdditionalNodeData) => void;
};
